import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import Icon from "../icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkDialog',
  props: {
    value: { type: Boolean },
    title: null,
    subTitle: null,
    link: null
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
  value: boolean
  title?: string
  subTitle?: string
  link: string
}





const linkCopied = ref(false)
const error = ref(false)

const onClose = () => {
  linkCopied.value = false
  emit("close")
}

const copyLinkToClipboard = () => {
  navigator.clipboard
    .writeText(props.link)
    .then(() => {
      linkCopied.value = true
    })
    .catch(() => {
      error.value = true
    })
}

return { __sfc: true,props, emit, linkCopied, error, onClose, copyLinkToClipboard, Icon }
}

})